module.exports = __webpack_public_path__ + "static/media/icon-drive-traffic.fac93e9a.svg";